module.exports = __webpack_public_path__ + "assets/img/life-8.6bc0f1c9.jpg";